<script>
export default {
    name: "ConsultantPaymentIndex",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    components: {

        "lab-items-tab" : () => import('./tabs/Lab.vue'),
        "radiology-items-tab": () => import('./tabs/Radiology.vue'),
        "theatre-items-tab": () => import('./tabs/Theatre.vue'),
        "other-items-tab": () => import('./tabs/Other.vue'),
    },

    methods: {
        print() {

            window.print();
        },
    }
}
</script>
<template>
<tail-base-layout>
    <template v-slot:content>
        <tail-card>
          <template v-slot:card-header>
            <h5 class="font-semibold text-base">Consultant Related Services</h5>
          </template>
          <template v-slot:card-body>
              <div class="w-full flex flex-wrap">
                  <ul class="w-full flex border-b-2 border-gray-500">
                      <li class="-mb-px mr-1">
                          <a @click.prevent="active=0" href="javascript:void(0)" 
                            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold" 
                            :class="active===0 ? activeClass : inActiveClass">Lab</a>
                      </li>
                      <li class="-mb-px mr-1">
                          <a @click.prevent="active=1" href="javascript:void(0)" 
                            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold" 
                            :class="active===1 ? activeClass : inActiveClass">Radiology</a>
                      </li>
                      <li class="-mb-px mr-1">
                          <a @click.prevent="active=2" href="javascript:void(0)" 
                            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold" 
                            :class="active===2 ? activeClass : inActiveClass">Theatre</a>
                      </li>
                      <li class="-mb-px mr-1">
                          <a @click.prevent="active=3" href="javascript:void(0)" 
                            class="btn-sm text-base text-gray-900 rounded-t-md inline-block px-4 font-bold" 
                            :class="active===3 ? activeClass : inActiveClass">Others</a>
                      </li>
                  </ul>
                  <lab-items-tab v-if="active===0"/>
                  <radiology-items-tab v-if="active===1"/>
                  <theatre-items-tab v-if="active===2" />
                  <other-items-tab v-if="active===3" />
              </div>
          </template>
          <template v-slot:card-footer>
              <div class="w-full text-right">
                <button @click.prevent="print"
                    class="btn-sm btn-info text-sm rounded mr-6"><i class="fa fa-print"></i> Print</button>
                  <router-link 
                    :to="{name: `auditing.auditing-dashboard.index`}" 
                    class="btn-sm btn-danger text-sm rounded">
                        <i class="fa fa-caret-left"></i> Back</router-link>
              </div>
          </template>
        </tail-card>
    </template>
</tail-base-layout>
</template>
<style>
.h-33 {
    max-height: 30rem;
    min-height: 20rem;
}
@media print {
    button, a {
        display: none;
    }
    .overflow-auto {
        overflow: visible !important;
    }

    .h-33 {
        max-height: none;
    }

    @page {
        size: A4 landscape;
    }
    tr { page-break-inside:avoid; page-break-after:auto; overflow: visible; }
    td {page-break-inside:avoid; page-break-after:auto; overflow: visible; }
    thead { display: table-row-group; }
    table {
         page-break-inside:auto;
    }
}
</style>
